var React = require('react');

function SearchWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.6531 19.4649L30 28.8118L28.8118 30L19.4649 20.6531C17.402 22.443 14.7089 23.5247 11.7624 23.5247C5.26605 23.5247 0 18.2587 0 11.7624C0 5.26605 5.26605 0 11.7624 0C18.2587 0 23.5247 5.26605 23.5247 11.7624C23.5247 14.7074 22.4415 17.4005 20.6531 19.4649ZM11.7639 21.8444C17.3315 21.8444 21.8459 17.33 21.8459 11.7624C21.8459 6.19474 17.33 1.68034 11.7624 1.68034C6.19474 1.68034 1.68034 6.19474 1.68034 11.7624C1.68034 17.33 6.19474 21.8444 11.7624 21.8444H11.7639Z","fill":"#ffffff"}));
}

SearchWhite.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = SearchWhite;

SearchWhite.default = SearchWhite;
